import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('files');

const filesRoutes = [
  {
    path: '/files',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '/',
        name: 'files',
        meta: { showNav: true, feature: 'files' },
        props: true,
        component: loadView('Files'),
      },
      {
        path: 'folders/:folderId',
        name: 'files-folder',
        meta: { showNav: true, feature: 'files' },
        props: true,
        component: loadView('Files'),
      },
    ],
  },
];

export default filesRoutes;
